import { useQuery } from 'react-query';
import RdBudgetFormService from '../../services/rdBudgetFormService';

const useRdBudgetFormQuery = (rentForecastId, options) => {
  const queryKey = ['useRdBudgetFormQuery', rentForecastId];

  return useQuery(
    queryKey,
    async () => {
      const rdBudgetForm = await new RdBudgetFormService().getRdBudgetForm(
        rentForecastId,
      );
      return rdBudgetForm;
    },
    {
      enabled: Boolean(rentForecastId),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      notifyOnChangeProps: ['data', 'error'],
      suspense: false,
      keepPreviousData: true,
      ...options,
    },
  );
};

export default useRdBudgetFormQuery;
